import { Component, ComponentFactoryResolver, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { PrimaryData, TaskStep } from 'app-models';
import { AppServicesLibraryService } from 'app-services-library';
import { CoverLetterLibraryComponent } from 'cover-letter-library';
import { DirtyFormGuard, MarkCleanFormAction } from 'dirty-check-store';
import { ToastrService } from 'ngx-toastr';
import { OrganizeDocumentsLibraryComponent } from 'organize-documents-library';
import { PlaceHolderDirective } from 'place-holder-library';
import { Subject } from 'rxjs';
import { first, takeUntil } from 'rxjs/operators';
import { StepStatusUpdatePayloadService } from 'step-status-update-payload-service';
import { SupportLetterLibraryComponent } from 'support-letter-library';
import { getStepDetails, updateStepStatus, updateStepStatusToInitialState } from 'visa-store';
import { ImmigrationWizardService } from '../services/immigration-wizard.service';

@Component({
  selector: 'app-generate-letters',
  templateUrl: './generate-letters.component.html',
  styleUrls: ['./generate-letters.component.scss']
})
export class GenerateLettersComponent implements OnInit, OnDestroy {

  inputData: any;
  observableSubscription$ = new Subject();
  wizardInput: any;
  isDataLoaded: boolean = false;
  constructor(private wizService: ImmigrationWizardService) {

  }

  ngOnInit(): void {
    this.wizService.getWizardTaskDetails$().pipe(takeUntil(this.observableSubscription$)).subscribe(res => {
      if(res) {
        this.inputData = {
          "superTaskId": res.superTaskId,
          "subTaskId": res.id,
          "caseType": res.subTaskTypeCode,
          "caseId": res.petitionId, // 1519
          "petitionId": res.petitionId,
          "foreignCompanyId": null,
          "visatype": res.taskTypeDetails.visaType,
          "visaName": res.taskTypeDetails.visaName,
          "petitionType": res.taskTypeDetails.petitionType,
          "immSpecialistId": res.immSpecialistId,
          "attorneyId": res.attorneyId,
          "sponsorId": res.sponsorId,
          "familyId": res.familyId,
          "immigrationCategory": null,
          "immigrationCategoryName": null,
          "immigrationClassification": null,
          "immigrationClassificationName": null,
          "superTaskTypeCode": res.superTaskTypeCode,
          "getTaskType": res.taskTypeDetails.visaType,
          "jsonInput": null,
          "beneficiaryId": res.beneficiaryId,
          "relationshipCode": null,
          "taskTypeId": res.taskTypeId,
          "taskTypeSaveJsonId": null,
          // "stepId": 8524,
          "companyId": res.companyId,
          "petitionerId": res.taskStepDetails[0].petitionerId,
          "stepName": "Generate Letters",
          "layoutCode": "FILL_FORM",
          "taskId": res.taskStepDetails[0].taskId,
          "isCustomStep": false,
          "taskTypeDetails": res.taskTypeDetails
          // "individualStepId": 6154,
          // "version": "wizard"
        };

        this.wizardInput = {
          title: 'Generate Forms & Letters',
          data: {
            taskId: res?.superTaskId,
            individual: res?.beneficiaryDetails?.firstName+" "+res?.beneficiaryDetails?.lastName,
            petitionType: res?.taskTypeDetails?.petitionType,
            status: res?.taskStatus?.name
          }
        }
        this.isDataLoaded = true; 
      }
    });

  }

  ngOnDestroy(): void {
    this.observableSubscription$.next();
    this.observableSubscription$.complete();    
  }
}
